import {
  Input as NextUIInput,
  InputProps as NextUIInputProps,
} from "@heroui/react";
import { forwardRef } from "react";
import { getInputClassNames } from "../../utils/styles";

type Color = Extract<NextUIInputProps["color"], "default">;
type LabelPlacement = Extract<NextUIInputProps["labelPlacement"], "outside">;
type Variant = Extract<NextUIInputProps["variant"], "bordered">;

export type InputProps = Omit<
  NextUIInputProps,
  "color" | "labelPlacement" | "variant"
> & {
  color?: Color;
  labelPlacement?: LabelPlacement;
  variant?: Variant;
};

export const Input = forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  return (
    <NextUIInput
      ref={ref}
      {...props}
      classNames={getInputClassNames(props.size)}
      color="default"
      data-testid={props.name}
      labelPlacement="outside"
      variant="bordered"
    />
  );
});

Input.displayName = "RecareUI.Input";
